import { useEffect, useState } from "react";
import { ADD_EMAIL_EVENT } from "@/app/shell/UserMenu";
import { AddEmailDialog } from "./AddEmailDialog";

/** Mounts once in the app shell; opens the dialog on the `pbranks:add-email` window event. */
export function AddEmailDialogHost() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onEvent = () => setOpen(true);
    window.addEventListener(ADD_EMAIL_EVENT, onEvent);
    return () => window.removeEventListener(ADD_EMAIL_EVENT, onEvent);
  }, []);
  return <AddEmailDialog open={open} onOpenChange={setOpen} />;
}
